// This is for the production site, which is hosted at https://angular.io
export const environment = {
  legacyUniversalAnalyticsId: 'UA-80456300-1', // Production id
  googleAnalyticsId: 'G-BVV0RDSG7F', // Production id
  production: true,
  mode: 'stable',
};
